import { useEffect, useState } from "react";
import { API, api } from "@/lib/api";

export function LinkHero({ kind, token, lang = "it", dark, compact }) {
  const [h, setH] = useState(null);
  useEffect(() => {
    api.get(`/public/hero/${kind}/${token}`).then((r) => setH(r.data)).catch(() => setH(false));
  }, [kind, token]);
  if (h === false) return null;
  const tx = h?.testi?.[lang] || h?.testi?.it;
  if (compact) {
    return (
      <div className="rounded-xl bg-white/95 text-[#0D2B3A] px-4 py-2.5 flex items-center gap-3" data-testid="link-hero">
        {h?.logos?.[0] && <img src={`${API}/public/logo/${h.logos[0]}`} alt={h.struttura} className="h-9 w-auto max-w-[110px] object-contain" data-testid="link-hero-logos" />}
        <div className="min-w-0">
          <div className="font-serif-it text-lg font-semibold leading-tight truncate" data-testid="link-hero-title">{tx?.titolo || "…"}</div>
          <div className="text-xs text-[#47606B] truncate" data-testid="link-hero-phrase">{tx?.frase || h?.struttura || ""}</div>
        </div>
      </div>
    );
  }
  return (
    <div className={`rounded-2xl px-5 py-6 sm:px-8 sm:py-7 text-center space-y-3 ${dark ? "bg-white/95 text-[#0D2B3A] shadow-2xl" : "bg-white shadow-xl border border-[#E9D7A8]"}`} data-testid="link-hero">
      {!h ? (
        <div className="space-y-3 animate-pulse" data-testid="link-hero-loading">
          <div className="h-12 w-40 mx-auto rounded-lg bg-[#EAF2F5]" />
          <div className="h-6 w-3/4 mx-auto rounded bg-[#EAF2F5]" />
          <div className="h-4 w-2/3 mx-auto rounded bg-[#F1F6F8]" />
        </div>
      ) : (
        <div className="fade-up space-y-3">
          {h.logos.length > 0 && (
            <div className="flex flex-wrap items-center justify-center gap-5" data-testid="link-hero-logos">
              {h.logos.map((k) => <img key={k} src={`${API}/public/logo/${k}`} alt={h.struttura || k} className={`${h.logos.length === 1 ? "h-16 sm:h-20 max-w-[240px]" : "h-10 sm:h-12 max-w-[150px]"} w-auto object-contain`} />)}
            </div>
          )}
          {!h.logos.length && h.struttura && <div className="text-xs uppercase tracking-[0.3em] text-[#A88B5C]">{h.struttura}</div>}
          <div className="mx-auto h-px w-16 bg-gradient-to-r from-transparent via-[#C9A96A] to-transparent" />
          <h2 className="font-serif-it text-3xl sm:text-4xl font-semibold leading-tight text-[#0D2B3A]" data-testid="link-hero-title">{tx.titolo}</h2>
          <p className="text-sm sm:text-base text-[#47606B] max-w-lg mx-auto" data-testid="link-hero-phrase">{tx.frase}</p>
        </div>
      )}
    </div>
  );
}
